(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("lGyDP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eb7032322018160d$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

// Keep this wrapper tiny; lazy-load the heavy app tree
const $eb7032322018160d$var$RootApp = /*#__PURE__*/ (0, $8NFma.lazy)(()=>(parcelRequire("kVsN0")));
const $eb7032322018160d$var$AtunwaPlayer = ({ dev: dev })=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).StrictMode, {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8NFma.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $1IdZj.jsx)($eb7032322018160d$var$RootApp, {
                dev: dev
            })
        })
    });
var $eb7032322018160d$export$2e2bcd8739ae039 = $eb7032322018160d$var$AtunwaPlayer;

});
parcelRegister("1IdZj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("89wqa"));

});
parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
'use strict';

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$k = Symbol.for("react.element"), $5ef850295e0236ca$var$l = Symbol.for("react.fragment"), $5ef850295e0236ca$var$m = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$n = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$5ef850295e0236ca$var$m.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $5ef850295e0236ca$var$n.current
    };
}
$5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$l;
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});


parcelRegister("kVsN0", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("8TD9g"))((parcelRequire("kI8SP")).resolve("iOpp6")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("bEPRd")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("3VupZ")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("i5Qhj"))
]).then(()=>parcelRequire('9obss'));

});
parcelRegister("8TD9g", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});



})();
//# sourceMappingURL=AtunwaPlayer.4c04188e.js.map
